var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('the-banner',{attrs:{"title":this.$lang.newsTitle,"description":this.$lang.newsSubtitle,"image":"cover.jpeg"}}),_c('markdown-wrapper',{staticClass:"body-block",attrs:{"id":"markdown","source":_vm.data.markdown}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }